<template>
  <div class="per-msg">
    <div class="subtitle">个人信息</div>
    <div class="info-dash flex">
      <div class="person-imx-box">
        <img
          :src="userInfo.avatarUrl || require('@/assets/images/head.png')"
          alt=""
          @mouseenter="mouseenter"
        />
        <div
          class="form-text"
          id="imgFom"
          @mouseenter="mouseenter"
          @mouseleave="mouseleave"
        >
          <el-upload
            :multiple="false"
            :show-file-list="false"
            class="image-uploader"
            action=""
            :http-request="handleSubmitImg"
            :before-upload="beforeAvatarUpload"
          >
            <el-button class="editlabel" size="medium" type="text"
              >更换头像</el-button
            >
          </el-upload>
        </div>
      </div>
      <div class="right">
        <div class="name">{{ userInfo.name || '--' }}</div>
        <div class="cells mb10">
          我的生日<span class="datace">{{ userInfo.birth || '--' }}</span>
        </div>
        <div class="cells mb10">
          绑定手机<span class="datace">{{ userInfo.showMobile || '--' }}</span>
        </div>
        <div class="cells">登录密码<span class="datace">******</span></div>
      </div>
      <div class="edit-btn pointer" @click="handleToEdit">编辑资料</div>
    </div>
  </div>
</template>

<script>
import { getInfo, saveObj } from '@/api/personal'
import fetch from '@/utils/fetch'
import { mapState } from 'vuex'
export default {
  data () {
    return {
    }
  },
  created () {
    this.moduleType = this.$route.query.moduleType
    this.getInfo()
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo || {}
    })
  },
  methods: {
    beforeAvatarUpload (file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      const isLt10M = file.size / 1024 / 1024 < 1
      if (!isJPG) {
        this.$message.error('请上传jpg,jpeg,png或者gif格式的图片!')
      }
      if (!isLt10M) {
        this.$message.error('上传大小不能超过 1MB!')
      }
      return isJPG && isLt10M
    },
    handleSubmitImg (arg) {
      const formData = new FormData()
      formData.append('file', arg.file)
      formData.append('isOpen', 'T')
      this.fileName = arg.file.name
      fetch({
        url: '/oss/endpoint/put-img',
        method: 'post',
        data: formData
      })
        .then((res) => {
          if (res.code === 0) {
            this.userInfo.avatarUrl = res.data.link
            this.handleSave()
          } else {
            this.$message.error(res.error)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleToEdit () {
      this.$router.push({ path: 'personalEdit', query: { moduleType: this.moduleType } })
    },
    mouseleave () {
      const imgFom = document.getElementById('imgFom')
      imgFom.style.display = 'none'
    },
    handleSave () {
      const data = {
        id: this.userInfo.id,
        avatarUrl: this.userInfo.avatarUrl,
        birth: this.userInfo.birth,
        name: this.userInfo.name
      }
      saveObj(data).then((res) => {
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.getInfo()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    mouseenter () {
      const imgFom = document.getElementById('imgFom')
      imgFom.style.display = 'block'
      console.log(2)
    },
    hideCode (str, frontLen, endLen) {
      var len = str.length - frontLen - endLen
      var xing = ''
      for (var i = 0; i < len; i++) {
        xing += '*'
      }
      return (
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
      )
    },
    getInfo () {
      getInfo().then((res) => {
        if (res.code === 0) {
          if (!res.data.mobile) {
            res.data.mobile = sessionStorage.getItem('mobile')
            res.data.showMobile = this.hideCode(res.data.mobile, 3, 4)
          }
          this.$store.dispatch('setUserInfo', res.data)
        } else {
          this.$message.error(res.error)
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.per-msg {
  padding: 40px;
  .subtitle {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;

    line-height: 26px;
    color: #9b232a;
  }
  .info-dash {
    width: 100%;
    border: 1px solid #cfd0d7;
    height: 220px;
    margin-top: 20px;
    position: relative;
    .person-imx-box {
      position: relative;
        width: 220px;
        height: 220px;
        display: flex;
        align-items: center;
        justify-content: center;
      img {
        width: 200px;
        height: 200px;
      }
      .form-text {
        width: 220px;
        position: absolute;
        background: rgba(0, 0, 0, 0.4);
        top: 0;
        left: 0;
        height: 220px;
        text-align: center;
        line-height: 220px;
        display: block;
        .editlabel {
          color: #fff;
          border: 1px solid #fff;
          padding: 6px 24px;
          border-radius: 8px;
        }
      }
    }

    .right {
      margin-top: 36px;
      margin-left: 20px;
      .name {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 26px;
        margin-bottom: 40px;
        color: #424855;
      }
      .cells {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 21px;
        color: #9fa1b0;
        .datace {
          color: #424855;
          margin-left: 10px;
        }
      }
    }
    .edit-btn {
      width: 140px;
      height: 44px;
      border: 1px solid #9b232a;
      text-align: center;
      line-height: 44px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #9b232a;
      position: absolute;
      right: 50px;
      top: 86px;
    }
  }
}
</style>
